import { AccessToken } from '~/AccessToken';
import { ImpersonateLoginResult, SwitchBackResult } from '~/Api/Authentication/Impersonate';

export enum ActionType {
	request = 'UserImpersonate.request',
	receive = 'UserImpersonate.receive',
	requestSwitchBack = 'UserImpersonate.requestSwitchBack',
	receiveSwitchBack = 'UserImpersonate.receiveSwitchBack',
}

export interface RequestAction {
	request: Promise<ImpersonateLoginResult>;
	type: ActionType.request;
}

export interface ReceiveAction {
	accessToken: AccessToken | null;
	request: Promise<ImpersonateLoginResult>;
	type: ActionType.receive;
}

export interface RequestSwitchBack {
	request: Promise<SwitchBackResult>;
	type: ActionType.requestSwitchBack;
}

export interface ReceiveSwitchBack {
	accessToken: AccessToken | null;
	request: Promise<SwitchBackResult>;
	type: ActionType.receiveSwitchBack;
}

export type Action = RequestAction | ReceiveAction | RequestSwitchBack | ReceiveSwitchBack;
